var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"59fda4a72e6cfeb7304660855ee36a3dd6a24a03"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docuclipper@docuclipper"]={id:"59fda4a72e6cfeb7304660855ee36a3dd6a24a03"};
      